import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { StatusContainer, MobileDocumentsView } from '@/features/Application/elements'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  margin-bottom: 18px;
`

const Mobile = ({ data = {}, isLocked, application, isLoading, standalone = false }) => {
  const { t } = useTranslation()
  const showStatus = true
  const { details = [], rate } = data

  const status = {
    poor: t('l.application.view.poor.label', 'Poor'),
    average: t('l.application.view.average.label', 'Average'),
    very_good: t('l.application.view.very_good.label', 'Very Good'),
    excellent: t('l.application.view.excellent.label', 'Excellent'),
    analyzing: t('l.application.view.analyzing.label', 'Analyzing')
  }

  const statusText = status[rate]
  const title = t('l.application.view.employment_verification.label', 'Employment Verification')
  const detailData = details?.[0]

  return (
    <Wrapper>
      <StatusContainer
        title={title}
        showStatus={showStatus}
        statusType={rate}
        statusTitle={statusText}
        isLocked={isLocked}
        isLoading={isLoading}
      >
        <MobileDocumentsView
          data={detailData}
          isLocked={isLocked}
          application={application}
          isEmploymentDoc
          isLoading={isLoading}
          tag="employment_verification"
          standalone={standalone}
        />
      </StatusContainer>
    </Wrapper>
  )
}

export default Mobile
